import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { IncrementDecrementDesktop as IncremenetDecrement } from '@alfa-bank/site-increment-decrement/desktop';
import { IncreaseDecreaseField } from '@alfa-bank/site-increase-decrease-field';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { useNamedContainers } from '@alfa-bank/site-named-container/utils';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { Aligner } from '@alfa-bank/site-aligner';
import { LinkPid as Link } from '@alfa-bank/site-link/link-pid';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import type { IDeps, TPilSamuraiCalculator } from '../models';
import { PilSamuraiCalculator as Component } from '../pil-samurai-calculator';

import styles from './desktop.css';

export const PilSamuraiCalculatorDesktop = createWidget<IDeps, TPilSamuraiCalculator>({
    Aligner,
    Block,
    Button,
    sendEvent,
    styles,
    Link,
    Text,
    useNamedContainers,
    IncreaseDecreaseField,
    IncremenetDecrement,
})(Component);
